import Vue from "vue";
import apiService from "./api-service"
import MbrService from "./mbrservice";
import HttpService from "./http-service";

class login {
    Login() {
        // 仿造登陆
        // let code = '4d485ef054c94588a92c5eb839cbcf41';// new HttpService().search('membercode');
        // document.cookie = "MemberToken=" + code;
        // return;
        var myUrl = escape(location.href)
        var api = new apiService();
        var Url = escape(api.ApiRoot + '/Mobile/Login?redirect=' + myUrl)
        var loginUrl = api.LoginUrl + '?goto=' + Url
        location.href = loginUrl;
    }

    //商城登录
    loginShop() {
        // 仿造登陆
        // let code = '4d485ef054c94588a92c5eb839cbcf41';// new HttpService().search('membercode');
        // document.cookie = "MemberToken=" + code;
        // return;
        let code = new HttpService().search('membercode');
        var api = new apiService();
        var Url = escape(location.origin + location.pathname + '#/login/loginShop');
        var loginUrl = api.LoginUrl + '?goto=' + Url;
        if (code == null || code == "") {
            location.href = loginUrl
        } else {
            new MbrService().LoginShop(code)
                .then(res => {
                    this.loginSuccess(res);
                }, err => {
                    alert(res.Message);
                });
        }
    }

    //登陆成功
    loginSuccess(res) {

        let gotoUrl = localStorage.getItem('gotoUrl');
        if (gotoUrl) {
            localStorage.setItem('gotoUrl', '');
            // alert("如果路径存在"+gotoUrl)
        } else {
            gotoUrl = location.origin + location.pathname;
            // alert("如果路径不存在" +gotoUrl)
        }
        if (res.Data.Token) {
           // localStorage.setItem('membertoken', res.Data.Token);
           //document.cookie("MemberToken",res.Data.Token);
           document.cookie="MemberToken="+res.Data.Token;
        }
        location.replace(gotoUrl);
    }
}
export default login





// WEBPACK FOOTER //
// ./src/services/login.js